import i18n, { TFunctionResult, TOptions } from 'i18next';

import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// 言語jsonファイルのimport
import translation_en from './en';
import translation_ja from './ja';

type RecursiveRecord = {
  [key in string]: string | RecursiveRecord;
};

type PickKeys<T extends RecursiveRecord, K = keyof T> = K extends string
  ? T[K] extends string
    ? K
    : `${K}.${PickKeys<Extract<T[K], RecursiveRecord>>}`
  : never;

type I18nDictionary = typeof translation_ja;
type I18nKey = PickKeys<I18nDictionary>;

const resources = {
  ja: {
    translation: translation_ja,
  },
  en: {
    translation: translation_en,
  },
};

i18n
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    resources,
    // lng: 'ja',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;

export const useTypeSafeTranslation = () => {
  return {
    t: (key: I18nKey | I18nKey[], options?: TOptions) =>
      i18n.t<TFunctionResult, I18nKey>(key, options)?.toString() ?? '!i18n Error!',
  };
};

export const getCurrentLanguage = () => i18n.language;

export const changeLanguage = (lang: string) => i18n.changeLanguage(lang);
